import { createSlice } from "@reduxjs/toolkit";
import { getJwtToken } from "../../services/auth.service";

const initialState = {
  // isAuth: getJwtToken() ? true : false,
  isAuth: true ,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const authSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {
    loggedin: (state, action) => {
      const { isAuth } = action.payload;
      state.isAuth = true;
    },
    signedOut: (state, action) => {
      const { isAuth } = action.payload;
      state.isAuth = false;
    },
  },
});
